import {Component, OnInit} from '@angular/core';
import { AppComponent } from 'src/app/app.component'; 
import { AppMainComponent } from 'src/app/app.main.component';
@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.scss']
})
export class AppMenuComponent implements OnInit {

    public model: any[];
    public activeLoader: boolean = true;

    constructor(public app: AppComponent, public appMain: AppMainComponent) {}

    ngOnInit() {
        let context = this;

        context.activeLoader = this.activeLoader;

        this.model = [
            {
                label: 'Firma', icon: 'pi pi-file-pdf',
                items: [
                    {label: 'Firma documento', icon: 'pi pi-file-pdf', routerLink: ['/document-sign']}
                ]
            }
        ];
    }
}
